import React from 'react';
import { APP_NAME } from 'configs/AppConfig';
import { Layout } from 'antd';

const { Footer } = Layout;

export default function AppFooter() {
  return (
    <Footer>
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{' '}
        <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.
      </span>
    </Footer>
  );
}
